import React, { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "src/hooks/redux";
import { selectCurrentInquiry } from "src/redux/currentInquiry/selectors";
import { getCurrentInquiryAsync } from "src/redux/currentInquiry/actions";
import { InquiryInfoCard } from "src/page-components/inquiries/[inquiry]/InquiryInfoCard";
import { SimilarInquiries } from "src/page-components/inquiries/[inquiry]/SimilarInquiries";
import { TextEditorView } from "src/components/TextEditor/TextEditorView";
import { MetadataWrapper } from "src/components/MetadataWrapper";
import { PageWrapper } from "src/components/Layouts/PageWrapper";
import { Loader } from "src/components/Loader";
import { BreadCrumbs } from "src/components/BreadCrumbs";
import { breadCrumbsTrns } from "src/components/BreadCrumbs/trns";
import { IBreadCrumbsItem } from "src/components/BreadCrumbs/types";
import { PATHNAMES } from "src/constants/routes";
import { Sizes } from "src/@types/sizes";
import { useExtractId } from "src/hooks/useExractId";

const InquiryItem = () => {
  const dispatch = useAppDispatch();

  const { item, isLoading } = useAppSelector(selectCurrentInquiry);

  const id = useExtractId();

  useEffect(() => {
    dispatch(getCurrentInquiryAsync({ id }));
  }, [dispatch, id]);

  const breadCrumbsItems: IBreadCrumbsItem[] = [
    { title: { i18nKey: breadCrumbsTrns.home }, path: PATHNAMES.HOME },
    { title: { i18nKey: breadCrumbsTrns.clones }, path: PATHNAMES.CLONES },
    { title: { i18nKey: item?.title } },
  ];

  if (!item && !isLoading) return null;

  return (
    <MetadataWrapper
      title={item?.inquiry_meta_title}
      description={item?.inquiry_meta_description}
    >
      <PageWrapper mainClassName="pt-10 pb-25 mt-19">
        {isLoading ? (
          <div className="flex justify-center items-center min-h-72">
            <Loader size={Sizes.XXL} />
          </div>
        ) : (
          <section className="container flex flex-col gap-5 gl:gap-10">
            <BreadCrumbs items={breadCrumbsItems} className="hidden gl:block" />

            <h1 className="font-semibold">{item.title}</h1>
            <div className="flex flex-col gl:flex-row gap-5 sm:gap-10 justify-between">
              <InquiryInfoCard {...item} />
              <div className="flex flex-col gap-10 flex-1">
                <TextEditorView>{item.additional_information}</TextEditorView>

                <SimilarInquiries id={item.id} />
              </div>
            </div>
          </section>
        )}
      </PageWrapper>
    </MetadataWrapper>
  );
};

export default InquiryItem;
